import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HalResource, HalResourceService, INIT_BY_JSON_2_TS} from '@drklein-pk/tng-angular-common';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {JsonObject, JsonProperty} from 'json2typescript';

type FieldType = 'STRING' | 'ZIPCODE' | 'NUMBER' | 'DECIMAL' | 'DATE' | 'CURRENCY' | 'COUNTRY' | 'SINGLE_SELECT'
    | 'MULTI_SELECT' | 'ARRAY' | 'OBJECT' | 'MEMO';

@JsonObject('ProductFieldResource')
export class ProductFieldResource extends HalResource {
  @JsonProperty('id', String)
  id: string = INIT_BY_JSON_2_TS;

  @JsonProperty('defaultValue', String)
  defaultValue: string = INIT_BY_JSON_2_TS;

  @JsonProperty('displayDescription', String)
  displayDescription: string = INIT_BY_JSON_2_TS;

  @JsonProperty('displayName', String)
  displayName: string = INIT_BY_JSON_2_TS;

  @JsonProperty('fieldType', String)
  fieldType: FieldType = INIT_BY_JSON_2_TS;

  @JsonProperty('length', Number)
  length: number = INIT_BY_JSON_2_TS;

  @JsonProperty('parameterName', String)
  parameterName: string = INIT_BY_JSON_2_TS;

  @JsonProperty('required', String)
  required: boolean = INIT_BY_JSON_2_TS;

  @JsonProperty('sortOrder', Number)
  sortOrder: number = INIT_BY_JSON_2_TS;
}

@JsonObject('ProductFieldResource')
class CollectionModelOfProductFieldResource extends HalResource  {
  @JsonProperty('_embedded', Object)
  _embedded: {
    productFields: ProductFieldResource[];
  } = INIT_BY_JSON_2_TS;
}

@Injectable()
export class LeadEndpointService extends HalResourceService<CollectionModelOfProductFieldResource> {
  constructor(httpClient: HttpClient) {
    super('leadSources', httpClient, CollectionModelOfProductFieldResource, '/api/leadendpointservice/v1');
  }

  getPlatformProductFields(productId: string): Observable<ProductFieldResource[]> {
    return this.findOneByRelativeUrl(`/platform-products/${productId}/fields`).pipe(
      map((fieldsCollection) => fieldsCollection._embedded?.productFields),
    );
  }
}
